import React, { useState } from 'react';
import Logo from '../../common/logo';
import Input from '../../common/input';
import { Password } from 'primereact/password';
import { Button } from 'primereact/button';
import { useAuth } from '../hooks/useAuth';
import './auth.css';

const AuthScreen: React.FC = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const { login, loading, error } = useAuth();

  const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setEmail(e.target.value);
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    await login(email, password);
  };

  return (
    <div className="login-container">
      <div className="login-form-section">
        <div className="login-form-content">
          <div className="login-logo">
            <Logo 
              src="/bm-logo.png" 
              alt="Bicicletas Mercurio Logo" 
            />
          </div>
          <h2>Inicia sesión en tu cuenta</h2>
          <form onSubmit={handleSubmit} className="login-form">
            {error && <div className="error-message">{error}</div>}
            <Input
              type="email"
              value={email}
              onChange={handleEmailChange}
              label="Correo electrónico"
              id="email"
              required
            />
            <div className="password-field">
              <label htmlFor="password" className="form-label">Contraseña <span style={{ color: 'red' }}>*</span></label>
              <Password
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                feedback={false}
                toggleMask
                className="form-input"
                required
              />
            </div>
            <Button   
              type="submit" 
              loading={loading}
              className="dark-button"
              label="Iniciar Sesión"
            />
          </form>
        </div>
      </div>
      <div className="login-image-section">
        {/* La imagen se aplica como fondo en CSS */}
      </div>
    </div>
  );
};

export default AuthScreen; 